const INV = "#0f766e";
const PT = "#f59e0b";

const Delta = ({ v }) => (
  <span style={{ color: v >= 0 ? "#059669" : "#dc2626", fontSize: 12, fontWeight: 800 }}>
    {v >= 0 ? "+" : ""}{v}
  </span>
);

export const SeminuevosMixBar = ({ mix }) => {
  const total = (mix.inventario || 0) + (mix.pt || 0);
  const invPct = total ? (mix.inventario / total) * 100 : 0;
  return (
    <div className="relative group mt-1 mb-1.5 cursor-help" data-testid="seminuevos-mix">
      <div className="flex h-1.5 rounded-full overflow-hidden bg-gray-100">
        <div style={{ width: `${invPct}%`, background: INV, transition: "width 400ms ease" }}/>
        <div style={{ width: `${100 - invPct}%`, background: PT, transition: "width 400ms ease" }}/>
      </div>
      <div className="flex items-center justify-between text-[12px] font-bold mt-0.5 text-gray-500">
        <span data-testid="seminuevos-mix-inventario">
          <span style={{ color: INV }}>■</span> Inventario {mix.inventario} <Delta v={mix.inventario_delta}/>
        </span>
        <span data-testid="seminuevos-mix-pt">
          <span style={{ color: PT }}>■</span> Pass-through {mix.pt} <Delta v={mix.pt_delta}/>
        </span>
      </div>
      <div className="absolute right-0 bottom-full mb-2 z-30 w-72 p-3 rounded-lg shadow-xl bg-gray-900 text-white
                      opacity-0 pointer-events-none translate-y-1 group-hover:opacity-100 group-hover:translate-y-0"
           style={{ transition: "opacity 150ms ease, transform 150ms ease" }}
           data-testid="seminuevos-mix-tooltip">
        <div className="text-[12px] font-extrabold uppercase tracking-wider text-gray-400 mb-1.5">
          Seminuevos · Inventario / Pass-through
        </div>
        <div className="flex justify-end gap-3 text-[12px] font-extrabold uppercase text-gray-400 mb-0.5">
          <span style={{ color: "#5eead4" }}>Inv</span><span style={{ color: "#fcd34d" }}>PT</span>
        </div>
        {(mix.by_sucursal || []).map((s) => (
          <div key={s.name} className="flex items-center justify-between text-[14px] font-semibold py-0.5">
            <span className="text-gray-200">{s.name}</span>
            <span className="flex items-center gap-2">
              <span style={{ color: "#5eead4" }}>{s.inventario} <Delta v={s.inventario_delta}/></span>
              <span style={{ color: "#fcd34d" }}>{s.pt} <Delta v={s.pt_delta}/></span>
            </span>
          </div>
        ))}
        <div className="text-[12px] text-gray-400 mt-1.5">Semana vigente · Δ vs semana anterior</div>
      </div>
    </div>
  );
};
